import { render, staticRenderFns } from "./wizardTraineeRegistration.vue?vue&type=template&id=8820f462&scoped=true"
import script from "./wizardTraineeRegistration.vue?vue&type=script&lang=js"
export * from "./wizardTraineeRegistration.vue?vue&type=script&lang=js"
import style0 from "./wizardTraineeRegistration.vue?vue&type=style&index=0&id=8820f462&prod&scoped=true&lang=css"
import style1 from "./wizardTraineeRegistration.vue?vue&type=style&index=1&id=8820f462&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8820f462",
  null
  
)

export default component.exports